<div class="mt-6">
  @if (loading) {
    <app-spinner />
  } @else {
    <app-card [title]="'Detalle de propuesta comercial'">
      <app-icon-button
        card-title-prefix
        [icon]="'arrow_back'"
        [ariaLabel]="'Volver al listado'"
        [title]="'Volver al listado'"
        (onClick)="close()"
      />
      <div card-actions>
        @if (editable) {
          <app-icon-button *hasPermission="'prospectos:edit'"
            (onClick)="editableSwitcher()"
            [ariaLabel]="'Editar'"
            [title]="'Editar'"
          />
        }
      </div>
      <!-- Fecha de contacto (solo lectura) -->
      <div class="mb-4 p-3 bg-gray-50 dark:bg-gray-800 rounded-lg">
        <div class="flex items-center gap-2">
          <mat-icon class="text-brand-500">event</mat-icon>
          <span class="text-sm text-gray-600 dark:text-gray-400">Fecha de contacto:</span>
          <span class="text-sm font-medium text-gray-900 dark:text-white">
            @if (contactoFecha) {
              {{ contactoFecha | date: 'dd/MM/yyyy' }}
            } @else {
              -
            }
          </span>
        </div>
      </div>

      <div class="mb-4 grid grid-cols-1 gap-3 md:grid-cols-3">
        <div class="rounded-lg bg-gray-50 p-3 text-sm text-gray-700 dark:bg-gray-800 dark:text-gray-300">
          <span class="text-gray-500 dark:text-gray-400">Creado por:</span>
          <span class="ml-1 font-medium">{{ userName || '-' }}</span>
        </div>
        <div class="rounded-lg bg-gray-50 p-3 text-sm text-gray-700 dark:bg-gray-800 dark:text-gray-300">
          <span class="text-gray-500 dark:text-gray-400">Última modificación por:</span>
          <span class="ml-1 font-medium">{{ userModName || '-' }}</span>
        </div>
        <div class="rounded-lg bg-gray-50 p-3 text-sm text-gray-700 dark:bg-gray-800 dark:text-gray-300">
          <span class="text-gray-500 dark:text-gray-400">Fecha última modificación:</span>
          <span class="ml-1 font-medium">
            @if (updatedAt) {
              {{ updatedAt | date: 'dd/MM/yyyy HH:mm' }}
            } @else {
              -
            }
          </span>
        </div>
      </div>

      <app-form [formGroup]="editForm">
        <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-3">
          <div>
            <app-label for="activo" className="mb-1!">Activo</app-label>
            <app-switch id="activo" formControlName="activo"></app-switch>
          </div>
          <div class="hidden md:block"></div>

          <div>
            <app-label for="presupuesto_nro">Número de presupuesto</app-label>
            <app-input-field id="presupuesto_nro" type="text" formControlName="presupuesto_nro" />
          </div>

          <div>
            <app-label for="estado">Estado</app-label>
            <app-select id="estado" formControlName="estado" placeholder="Seleccione un estado" [options]="estadoOptions" />
          </div>

          <div>
            <app-label for="fecha_generacion_presupuesto">Fecha de generación</app-label>
            <app-input-field id="fecha_generacion_presupuesto" type="date" formControlName="fecha_generacion_presupuesto" />
          </div>

          <div>
            <app-label for="fecha_envio_presupuesto">Fecha de envío</app-label>
            <app-input-field id="fecha_envio_presupuesto" type="date" formControlName="fecha_envio_presupuesto" />
          </div>

          <div>
            <app-label for="monto">Monto</app-label>
            <app-input-field id="monto" type="number" formControlName="monto" />
          </div>

          <div>
            <app-label for="descuento">Descuento</app-label>
            <app-input-field id="descuento" type="number" formControlName="descuento" />
          </div>

          @if (editForm.get('estado')?.value === 'rechazada') {
            <div class="md:col-span-2">
              <app-label for="motivo_rechazo">Motivo de rechazo</app-label>
              <app-textarea id="motivo_rechazo" formControlName="motivo_rechazo" [rows]="3" />
            </div>
          }

          <div class="md:col-span-2 mt-2 md:mt-4">
            <div class="flex items-center gap-2">
              <app-checkbox formControlName="confirmacion_recepcion" label="Confirmación de recepción" />
            </div>
            <div class="mt-3">
              <app-label for="fecha_confirmacion_recepcion">Fecha de confirmación de recepción</app-label>
              <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
                <app-input-field id="fecha_confirmacion_recepcion" type="date" formControlName="fecha_confirmacion_recepcion" />
                <div class="hidden md:block"></div>
              </div>
            </div>
          </div>

        </div>

        <div>
          <app-label for="descripcion">Descripción</app-label>
          <app-textarea id="descripcion" formControlName="descripcion" [rows]="4" />
        </div>
      </app-form>

      @if (!editable && permissionAuth.canEdit('prospectos')) {
        <label
          for="path"
          class="mt-3 shadow-theme-xs group hover:border-brand-500 block cursor-pointer rounded-lg border-2 border-dashed bg-gray-50 border-gray-300 transition dark:hover:border-brand-400 dark:border-gray-700 dark:bg-gray-900"
        >
          <div class="flex justify-center p-5">
            <div class="flex flex-col items-center">
              <div class="inline-flex h-13 w-13 mb-3 items-center justify-center rounded-full bg-gray-200 text-gray-700  transition dark:bg-gray-800 dark:text-gray-400">
                <mat-icon>file_upload</mat-icon>
              </div>

              <h4 class="font-semibold text-gray-800 text-theme-xl dark:text-white/90">
                Subir y reemplazar archivo
              </h4>

              <span class="font-medium underline text-theme-sm text-brand-500">
                Examinar archivo
              </span>
            </div>
          </div>
          <input type="file" id="path" class="hidden" accept=".pdf,application/pdf" (change)="onFileSelected($event)" />
        </label>

        @if (fileSelected) {
          <div class="flex justify-center items-center mt-4">
            <div class="relative overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm min-w-36 max-w-36 dark:border-gray-800 dark:bg-white/[0.03]">
              <div class="flex flex-col items-center">
                <mat-icon class="px-3 py-5 text-6xl! w-auto! h-auto! text-gray-700! dark:text-gray-400!">insert_drive_file</mat-icon>
                <div class="flex flex-col p-3 w-full bg-gray-100 dark:bg-white/[0.05]">
                  <small class="truncate text-gray-700 dark:text-gray-400" [matTooltip]="fileSelected.name">{{fileSelected.name}}</small>
                </div>
              </div>
              <button
                class="absolute! top-1 right-1"
                mat-icon-button
                (click)="fileSelected = null"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
        }
      }

      <!-- Archivo principal -->
      <div class="mt-6 border-t pt-6">
        <h3 class="text-lg font-medium text-gray-800 dark:text-white mb-4">Archivo principal</h3>

        @if (archivoPrincipal) {
          <div class="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-800 rounded-lg">
            <div class="flex items-center gap-3 flex-1">
              <mat-icon class="text-brand-500">insert_drive_file</mat-icon>
              <div class="flex-1">
                <p class="text-sm font-medium text-gray-900 dark:text-white truncate">
                  {{ getArchivoNombre(archivoPrincipal) }}
                </p>
              </div>
            </div>

            <div class="flex items-center gap-2">
              <button
                mat-icon-button
                [matTooltip]="'Descargar'"
                (click)="downloadArchivoPrincipal()"
                class="text-gray-500 dark:text-gray-400 hover:text-brand-500"
              >
                <mat-icon>download</mat-icon>
              </button>
            </div>
          </div>
        } @else {
          <div class="text-center py-4">
            <p class="text-gray-500 dark:text-gray-400">No hay archivo principal</p>
          </div>
        }
      </div>

      <!-- Sección de archivos múltiples -->
      <div class="mt-6 border-t pt-6">
        <h3 class="text-lg font-medium text-gray-800 dark:text-white mb-4">Archivos adjuntos</h3>

        <!-- Formulario para agregar nuevo archivo -->
        <div class="mb-4 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg">
          <label
            for="newArchivo"
            class="shadow-theme-xs group hover:border-brand-500 block cursor-pointer rounded-lg border-2 border-dashed bg-white border-gray-300 transition dark:hover:border-brand-400 dark:border-gray-700 dark:bg-gray-900 mb-3"
          >
            <div class="flex justify-center p-5">
              <div class="flex flex-col items-center">
                <div class="inline-flex h-10 w-10 mb-2 items-center justify-center rounded-full bg-gray-200 text-gray-700 transition dark:bg-gray-800 dark:text-gray-400">
                  <mat-icon>add</mat-icon>
                </div>
                <span class="font-medium text-sm text-gray-700 dark:text-gray-300">
                  Agregar archivo
                </span>
              </div>
            </div>
            <input type="file" id="newArchivo" class="hidden" accept=".pdf,application/pdf" (change)="onNewArchivoSelected($event)" />
          </label>

          @if (newArchivoFile) {
            <div class="mb-3">
              <div class="flex items-center gap-2 p-2 bg-white dark:bg-gray-900 rounded">
                <mat-icon class="text-brand-500">insert_drive_file</mat-icon>
                <span class="text-sm truncate flex-1">{{newArchivoFile.name}}</span>
                <button
                  mat-icon-button
                  (click)="newArchivoFile = null"
                  class="text-gray-500 dark:text-gray-400"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>

            <div class="mb-3">
              <app-label for="newArchivoDescripcion">Descripción (opcional)</app-label>
              <app-input-field id="newArchivoDescripcion" type="text" [(ngModel)]="newArchivoDescripcion" placeholder="Descripción del archivo" />
            </div>

            <app-button *hasPermission="'prospectos:create'"
              variant="primary"
              [loading]="uploadingArchivo"
              (btnClick)="uploadArchivo()"
            >
              Subir archivo
            </app-button>
          }
        </div>

        <!-- Lista de archivos -->
        @if (loadingArchivos) {
          <app-spinner />
        } @else {
          @if (archivos && archivos.length > 0) {
            <div class="grid grid-cols-1 gap-3">
              @for (archivo of archivos; track archivo.id; let index = $index) {
                <div class="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-800 rounded-lg">
                  <div class="flex items-center gap-3 flex-1">
                    <mat-icon class="text-brand-500">insert_drive_file</mat-icon>
                    <div class="flex-1">
                      <p class="text-sm font-medium text-gray-900 dark:text-white truncate">
                        Archivo {{index + 1}}
                      </p>
                      @if (archivo.descripcion) {
                        <p class="text-xs text-gray-500 dark:text-gray-400">
                          {{archivo.descripcion}}
                        </p>
                      }
                    </div>
                  </div>

                  <div class="flex items-center gap-2">
                    <button
                      mat-icon-button
                      [matTooltip]="'Descargar'"
                      (click)="downloadArchivo(archivo.id)"
                      class="text-gray-500 hover:text-brand-500"
                    >
                      <mat-icon>download</mat-icon>
                    </button>

                    <app-delete-trigger *hasPermission="'prospectos:delete'"
                      [title]="'Eliminar archivo'"
                      [disabled]="deletingArchivo && (deletingArchivoIndex === index)"
                      (clickDeleteEvent)="deleteArchivo(archivo.id, index)"
                    />
                  </div>
                </div>
              }
            </div>
          } @else {
            <div class="text-center py-8">
              <p class="text-gray-500 dark:text-gray-400">No hay archivos adjuntos</p>
            </div>
          }
        }
      </div>
    </app-card>

    <app-edition-buttons *hasPermission="'prospectos:edit'"
      [valid]="editForm.valid"
      [process]="updating"
      [editable]="editable"
      [hideEditButton]="true"
      (onGoBackClick)="close()"
      (onEditClick)="editableSwitcher()"
      (onCancelClick)="refreshPropuesta()"
      (onUpdateClick)="update()"
    />
  }
</div>
